/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideen für einen Zwischenstopp`
};

const en_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Stopover ideas`
};

const es_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideas de paradas`
};

const fr_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Idées d’escales`
};

const it_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Idee per una sosta`
};

const nl_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideeën voor tussenstops`
};

const pt_zoi__title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideias de escala`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__title", locale)
	if (locale === "de") return de_zoi__title(inputs)
	if (locale === "en") return en_zoi__title(inputs)
	if (locale === "es") return es_zoi__title(inputs)
	if (locale === "fr") return fr_zoi__title(inputs)
	if (locale === "it") return it_zoi__title(inputs)
	if (locale === "nl") return nl_zoi__title(inputs)
	return pt_zoi__title(inputs)
};